import React, { useState } from 'react';
import { ASSET_URL } from '../../../../helper/api_url';
import { getTrialStatus, openGoogleMap, truncateText } from '../EnquiryList/enquiryUtils';
import { AddressModal } from '../EnquiryList/AddressModal';

export const MeetingSchoolCell = ({ row, handleReport }) => {
    const [showAddressModal, setShowAddressModal] = useState(false);

    const enquiry = row.enquiry || {};
    const imageUrl = ASSET_URL + enquiry.avatar;
    const trialStatus = getTrialStatus(enquiry.tryal_date, enquiry.tryal_period);
    const address = enquiry.address_1 || enquiry.address || '';
    const truncated = truncateText(address, 28);

    return (
        <div className="d-flex align-items-center gap-2 py-1">
            {/* Avatar with Status Bubble */}
            <div className="avatar-status-wrapper flex-shrink-0">
                <img
                    className="rounded-circle border"
                    style={{ width: '38px', height: '38px', objectFit: 'cover' }}
                    src={imageUrl}
                    alt={enquiry.name || 'School Avatar'}
                />
                <span
                    className="status-bubble status-bubble-info"
                    title="Status: Meeting Arrange"
                />
            </div>

            {/* School Details */}
            <div style={{ minWidth: 0 }}>
                {/* School Name & Trial Status */}
                <div className="d-flex align-items-center gap-1.5 flex-wrap">
                    <span
                        role="button"
                        onClick={() => handleReport && handleReport(row)}
                        className="fw-semibold text-dark fs-13 text-truncate d-inline-block school-name-link cursor-pointer"
                        style={{ maxWidth: '220px', cursor: 'pointer' }}
                        title={`Click to view history report for ${enquiry.name || 'School'}`}
                    >
                        {enquiry.name || 'Candidate / School'}
                    </span>
                    {trialStatus && (
                        <span className={`badge ${trialStatus.badgeClass} fs-11 px-2 py-0.5`}>
                            {trialStatus.label}
                        </span>
                    )}
                </div>

                {/* Truncated Address */}
                <div className="fs-12 text-muted lh-sm text-truncate mt-0.5" style={{ maxWidth: '240px' }}>
                    {address ? (
                        <span>
                            {truncated.displayText}
                            {truncated.isTruncated && (
                                <span
                                    className="badge bg-soft-primary text-primary ms-1 cursor-pointer address-dot-trigger"
                                    onClick={() => setShowAddressModal(true)}
                                    title="Click to view full address"
                                    role="button"
                                >
                                    ...more
                                </span>
                            )}
                        </span>
                    ) : (
                        <span className="fst-italic text-muted">No address provided</span>
                    )}
                </div>

                {/* District & Location Links */}
                <div className="d-flex align-items-center gap-2 mt-1">
                    {enquiry.district && (
                        <span className="badge bg-light text-secondary border fs-10 px-1.5 py-0.5">
                            <i className="ri-map-pin-line me-0.5" />
                            {enquiry.district}
                        </span>
                    )}
                    {enquiry.feedback && (
                        <button
                            type="button"
                            className="btn btn-link p-0 text-success fs-11 text-decoration-none d-inline-flex align-items-center"
                            onClick={() => openGoogleMap(enquiry.feedback)}
                            title="Open Google Maps location"
                        >
                            <i className="ri-map-pin-2-fill me-0.5 text-danger" />
                            Map
                        </button>
                    )}
                </div>
            </div>

            {/* Address Modal popup for full address inspection */}
            <AddressModal
                isOpen={showAddressModal}
                toggle={() => setShowAddressModal(false)}
                address={address}
                district={enquiry.district}
                state={enquiry.state}
                pin={enquiry.pin}
                schoolName={enquiry.name}
                googleMapUrl={enquiry.feedback}
            />
        </div>
    );
};

export default MeetingSchoolCell;
